import { rem } from './utils/index.js';
export var maxWidth = {
    '2xl': rem(1300),
    xl: rem(1240),
    lg: rem(1100),
    md: rem(980),
    sm: rem(820),
    xs: rem(675)
};

//# sourceMappingURL=maxWidth.js.map